import React, { FC } from 'react';
import { withFullHydrate } from '@ecommerce/nest-ssr/common';
import MainLayoutMobile from 'layouts/main-layout/main-layout.mobile';
import Container from 'atomic/container';
import { CatProductsDsData } from 'modules/shared/widgets/interfaces/datasources/cat-products-ds-data.interface';
import HomeProductsCarouselMobile from './components/home-products-carousel/home-products-carousel-mobile';
import SrcSizes from 'modules/shared/components/src-sizes/src-sizes';
import { homeImages } from './home.data';
import HomeDescription from './components/home-description';

import './index.mobile.scss';

interface HomeMobileProps {
    categoriesProducts: CatProductsDsData[];
    isBot: boolean;
}

const HomeMobile: FC<HomeMobileProps> = ({ categoriesProducts, isBot }) => {
    return (
        <MainLayoutMobile
            disableAdSlots={true}
        >
            <Container>
                <div className="home-mobile__banner">
                    <a
                        className="home-mobile__link"
                        href={homeImages.banner.url}
                        aria-label={homeImages.banner.name}
                    >
                        <SrcSizes
                            className="home-mobile__image"
                            isMobile={true}
                            alt={homeImages.banner.name}
                            title={homeImages.banner.name}
                            width={400}
                            height={250}
                            image={homeImages.banner.image}
                            imageSizes={[
                                { image: homeImages.banner.image, width: 1116 },
                                { image: homeImages.banner.imageRetina, width: 1908 }
                            ]}
                        />
                    </a>
                </div>
                <HomeProductsCarouselMobile
                    categoryProducts={categoriesProducts[0]}
                    isBot={isBot}
                />
                <div className="home-mobile__images home-mobile__images--small">
                    <a
                        className="home-mobile__link"
                        href={homeImages.bannerTopLeft.url}
                        aria-label={homeImages.bannerTopLeft.name}
                    >
                        <SrcSizes
                            className="home-mobile__image"
                            isMobile={true}
                            alt={homeImages.bannerTopLeft.name}
                            title={homeImages.bannerTopLeft.name}
                            width={200}
                            height={100}
                            image={homeImages.bannerTopLeft.image}
                            imageSizes={[
                                { image: homeImages.bannerTopLeft.image, width: 700 },
                                { image: homeImages.bannerTopLeft.imageRetina, width: 1180 }
                            ]}
                        />
                    </a>
                    <a
                        className="home-mobile__link"
                        href={homeImages.bannerTopRight.url}
                        aria-label={homeImages.bannerTopRight.name}
                    >
                        <SrcSizes
                            className="home-mobile__image"
                            isMobile={true}
                            alt={homeImages.bannerTopRight.name}
                            title={homeImages.bannerTopRight.name}
                            width={200}
                            height={100}
                            image={homeImages.bannerTopRight.image}
                            imageSizes={[
                                { image: homeImages.bannerTopRight.image, width: 700 },
                                { image: homeImages.bannerTopRight.imageRetina, width: 1180 }
                            ]}
                        />
                    </a>
                </div>
                <HomeProductsCarouselMobile
                    categoryProducts={categoriesProducts[1]}
                    isBot={isBot}
                />
                <div className="home-mobile__images home-mobile__images--medium">
                    <a
                        className="home-mobile__link"
                        href={homeImages.bannerMiddleTop.url}
                        aria-label={homeImages.bannerMiddleTop.name}
                    >
                        <SrcSizes
                            className="home-mobile__image"
                            isMobile={true}
                            alt={homeImages.bannerMiddleTop.name}
                            title={homeImages.bannerMiddleTop.name}
                            width={200}
                            height={150}
                            image={homeImages.bannerMiddleTop.image}
                            imageSizes={[
                                { image: homeImages.bannerMiddleTop.image, width: 450 },
                                { image: homeImages.bannerMiddleTop.imageRetina, width: 772 }
                            ]}
                        />
                    </a>
                    <a
                        className="home-mobile__link"
                        href={homeImages.bannerMiddleBottom.url}
                        aria-label={homeImages.bannerMiddleBottom.name}
                    >
                        <SrcSizes
                            className="home-mobile__image"
                            isMobile={true}
                            alt={homeImages.bannerMiddleBottom.name}
                            title={homeImages.bannerMiddleBottom.name}
                            width={200}
                            height={150}
                            image={homeImages.bannerMiddleBottom.image}
                            imageSizes={[
                                { image: homeImages.bannerMiddleBottom.image, width: 450 },
                                { image: homeImages.bannerMiddleBottom.imageRetina, width: 772 }
                            ]}
                        />
                    </a>
                </div>
                <HomeProductsCarouselMobile
                    categoryProducts={categoriesProducts[2]}
                    isBot={isBot}
                />
                <div className="home-mobile__images home-mobile__images--large">
                    <a
                        className="home-mobile__link"
                        href={homeImages.bannerMiddleLeft.url}
                        aria-label={homeImages.bannerMiddleLeft.name}
                    >
                        <SrcSizes
                            className="home-mobile__image"
                            isMobile={true}
                            alt={homeImages.bannerMiddleLeft.name}
                            title={homeImages.bannerMiddleLeft.name}
                            width={200}
                            height={250}
                            image={homeImages.bannerMiddleLeft.image}
                            imageSizes={[
                                { image: homeImages.bannerMiddleLeft.image, width: 450 },
                                { image: homeImages.bannerMiddleLeft.imageRetina, width: 772 }
                            ]}
                        />
                    </a>
                    <a
                        className="home-mobile__link"
                        href={homeImages.bannerMiddleRight.url}
                        aria-label={homeImages.bannerMiddleRight.name}
                    >
                        <SrcSizes
                            className="home-mobile__image"
                            isMobile={true}
                            alt={homeImages.bannerMiddleRight.name}
                            title={homeImages.bannerMiddleRight.name}
                            width={200}
                            height={250}
                            image={homeImages.bannerMiddleRight.image}
                            imageSizes={[
                                { image: homeImages.bannerMiddleRight.image, width: 450 },
                                { image: homeImages.bannerMiddleRight.imageRetina, width: 772 }
                            ]}
                        />
                    </a>
                </div>
                <HomeProductsCarouselMobile
                    categoryProducts={categoriesProducts[3]}
                    isBot={isBot}
                />
                <div className="home-mobile__images home-mobile__images--small">
                    <a
                        className="home-mobile__link"
                        href={homeImages.bannerBottomLeft.url}
                        aria-label={homeImages.bannerBottomLeft.name}
                    >
                        <SrcSizes
                            className="home-mobile__image"
                            isMobile={true}
                            alt={homeImages.bannerBottomLeft.name}
                            title={homeImages.bannerBottomLeft.name}
                            width={200}
                            height={100}
                            image={homeImages.bannerBottomLeft.image}
                            imageSizes={[
                                { image: homeImages.bannerBottomLeft.image, width: 700 },
                                { image: homeImages.bannerBottomLeft.imageRetina, width: 1180 }
                            ]}
                        />
                    </a>
                    <a
                        className="home-mobile__link"
                        href={homeImages.bannerBottomRight.url}
                        aria-label={homeImages.bannerBottomRight.name}
                    >
                        <SrcSizes
                            className="home-mobile__image"
                            isMobile={true}
                            alt={homeImages.bannerBottomRight.name}
                            title={homeImages.bannerBottomRight.name}
                            width={200}
                            height={100}
                            image={homeImages.bannerBottomRight.image}
                            imageSizes={[
                                { image: homeImages.bannerBottomRight.image, width: 700 },
                                { image: homeImages.bannerBottomRight.imageRetina, width: 1180 }
                            ]}
                        />
                    </a>
                </div>
                <HomeDescription
                    isMobile={true}
                />
            </Container>
        </MainLayoutMobile>
    );
};

export default withFullHydrate(HomeMobile, { root: '#root' }, 'views/pages/static-pages/home/index.mobile');
